function updateLinks(){

var link= document.querySelectorAll('a[href*="/collections"]')

link.forEach(tag => {
 var original_url = tag.href;
var filter = "?filter.v.availability=1&" ;
  if (tag.href.indexOf('filter.') == -1) {
      var filter_query = "?filter.v.availability=1";
      tag.href = original_url + filter_query
    }
   
}
     )
  
}
updateLinks()